import styled from 'styled-components';
import { MaxIcon, TGIcon, VBIcon, VKIcon, WSIcon } from './Icons';
import config from '../core/config';
import { useState, useEffect } from 'react';
import { Spin } from 'antd';

const HelpComponent = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        // Сначала пробуем загрузить с сервера
        const response = await fetch('https://lk2.sitiy.ru/video-manifest.json');
        const data = await response.json();

        setVideos(data.videos || []);
      } catch (error) {
        console.error('Ошибка загрузки с сервера, загружаем локальный:', error);
        try {
          // Fallback на локальный файл из public
          const localResponse = await fetch('/video-manifest.json');
          const localData = await localResponse.json();
          setVideos(localData.videos || []);
        } catch (localError) {
          console.error('Ошибка загрузки локального манифеста:', localError);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  return (
    <Wrapper>
      <SectionTitle>По любым вопросам обращайтесь в чат поддержку или своему менеджеру:</SectionTitle>
      <Contacts>
        <IconButton href={config.socialLinks.telegramSupportBot} target="_blank" rel="noopener noreferrer" bgColor="#C0DAEC">
          <TGIcon/>
        </IconButton>
        <IconButton href={config.socialLinks.max} target="_blank" rel="noopener noreferrer" bgColor="#903FFF">
          <MaxIcon/>
        </IconButton>
        <IconButton href={config.socialLinks.vk} target="_blank" rel="noopener noreferrer" bgColor="#A2C2E7">
          <VKIcon/>
        </IconButton>
        <PhoneLink href={`tel:${config.socialLinks.phone.replace(/[^+\d]/g, '')}`}>{config.socialLinks.phone}</PhoneLink>
      </Contacts>

      <SectionTitle>Видео уроки по работе с личным кабинетом</SectionTitle>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin />
        </div>
      ) : (
        <VideoList>
          {videos.map((video) => (
            <VideoCard key={video.id}>
              <video controls preload="metadata" src={video.url}>
                Ваш браузер не поддерживает воспроизведение видео.
              </video>
              <div>{video.title}</div>
            </VideoCard>
          ))}
        </VideoList>
      )}
    </Wrapper>
  );
};

export default HelpComponent;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Contacts = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;

const IconButton = styled.a`
  position: relative;
  min-width: 40px;
  min-height: 40px;
  border-radius: 12px;
  background-color: ${(props) => props.bgColor || '#EA394B'};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  color: #ffffff !important;
  text-decoration: none;
  transition: transform 0.3s ease, opacity 0.3s ease;
  &:hover {
    transform: scale(1.05);
    color: #ffffff;
    text-decoration: none;
  }
  @media (max-width: 798px) {
    min-width: 45px;
    min-height: 45px;
  }
`;

const SectionTitle = styled.h3`
  margin-bottom: 12px;
  color: #999;
`;

const VideoList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
`;

const VideoCard = styled.div`
  background: #f5f5f5;
  border-radius: 6px;
  min-width: 220px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  & > video {
    width: 100%;
    height: auto;
    border-radius: 6px;
    background: black;
  }
`;

const PhoneLink = styled.a`
  display: block;
  margin-top: 8px;
  font-size: 24px;
  color: inherit;
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;
